import React from 'react';
import {
	type MenuNode,
	MenuNodeType,
} from '@atlassian/jira-software-context-menu/src/common/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { AgentPickerBulk } from '@atlassian/jira-autodev-agent-picker-bulk/src/ui/index.tsx';

import { useIntl } from '@atlassian/jira-intl';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useIsAutoDevEnabled } from '@atlassian/jira-autodev-common/src/services/use-is-autodev-enabled/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import getRelayEnvironment from '@atlassian/jira-relay-environment/src/index.tsx';
import { USE_AGENT_MENU_ID, USE_AGENT_NODE_MENU_ID } from '../../constants.tsx';
import { createSeparator } from '../separator/index.tsx';
import messages from './messages.tsx';

// cardIds are plan issue ids, not ARIs such as 10001
export const useUseAgent = (cardIds: number[]): MenuNode[] => {
	const { formatMessage } = useIntl();
	const cloudId = useCloudId();
	const atlassianAccountId = useAccountId();
	const [isAutoDevEnabled] = useIsAutoDevEnabled(
		atlassianAccountId,
		cloudId,
		getRelayEnvironment(),
	);

	if (!fg('autodev-verticals-bulk-agents-backlog') || !isAutoDevEnabled) {
		return [];
	}
	return [
		createSeparator(USE_AGENT_MENU_ID),
		{
			type: MenuNodeType.Item,
			label: formatMessage(messages.useAgent),
			id: USE_AGENT_MENU_ID,
			submenuWidth: 320,
			children: [
				{
					type: MenuNodeType.Node,
					id: USE_AGENT_NODE_MENU_ID,
					node: ({ closeMenu }) => (
						<AgentPickerBulk
							issueIds={cardIds.map(String)}
							menuContextLocation="backlog_context_menu"
							onClose={closeMenu}
						/>
					),
				},
			],
		},
	];
};
